import { Button } from '@/shared/ui/Button';
import styles from './CompleteStep.module.css';

interface CompleteStepProps {
  onComplete: () => void;
  isLoading: boolean;
}

export function CompleteStep({ onComplete, isLoading }: CompleteStepProps) {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="24" fill="var(--color-primary-100)" />
          <path
            d="M14 24L21 31L34 18"
            stroke="var(--color-primary)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h2 className={styles.title}>You're all set!</h2>
      <p className={styles.description}>
        Your practice profile is ready. PracticeNova will now start analyzing your digital presence and generating
        personalized recommendations to help you grow.
      </p>
      <div className={styles.features}>
        <div className={styles.feature}>
          <span className={styles.featureIcon}>SEO</span>
          <span>SEO analysis running in the background</span>
        </div>
        <div className={styles.feature}>
          <span className={styles.featureIcon}>AI</span>
          <span>AI recommendations will be ready within 24 hours</span>
        </div>
        <div className={styles.feature}>
          <span className={styles.featureIcon}>Rep</span>
          <span>Reputation monitoring has been activated</span>
        </div>
      </div>
      <Button onClick={onComplete} isLoading={isLoading} size="lg">
        Go to Dashboard
      </Button>
    </div>
  );
}
